import clsx from 'clsx';
import { DayType, MonthType } from '../DatesCalendar.types';
import { Day } from '../Day';
import styles from './Month.css';

interface WeekDay {
	label: string;
	code: string;
}

interface MonthProps {
	year: string;
	month: MonthType;
	weekDays: Array<WeekDay>;
	onDayClick: (day: DayType) => void;
}

const Month = ({ year, month, weekDays, onDayClick }: MonthProps) => {
	return (
		<div className={clsx(styles.month)}>
			<span className={styles.title}>
				{month.label} {year}
			</span>
			<div className={styles.monthGrid}>
				{weekDays.map((day: WeekDay) => (
					<div key={day.label} className={styles.dayLabel}>
						{day.code}
					</div>
				))}
				{month.days.map((day, index) => {
					if (day === null) return <span key={index}></span>;
					return <Day day={day} onDayClick={onDayClick} key={day.code} testId="day-label-button" />;
				})}
			</div>
		</div>
	);
};

export { Month };
